import { useMemo } from "react";

export default function VoteStepper({
  value = 0,
  min = 0,
  max = Infinity,
  onChange,
  // onZeroRemove is no longer used, but we keep it in the props for compatibility
  onZeroRemove,
  isBusy = false,
  size = "md",
  ariaLabel = "Votes",
}) {
  const clamp = useMemo(
    () => (n) => Math.max(min, Math.min(max, n)),
    [min, max]
  );

  // Display-only: no optimistic local increments.
  // Prevents “infinite” UI changes if the server rejects extra votes.
  const step = (delta) => {
    if (isBusy) return;
    // Even at 0, allow a -1 to be sent (server may delete the comment).
    onChange?.(clamp(value + delta), delta);
  };

  const sizeClass =
    size === "sm" ? "vote-sm" : size === "lg" ? "vote-lg" : "vote-md";

  const canDec = !isBusy; // allow minus even at 0
  const canInc = value < max && !isBusy;

  return (
    <div className={`vote-stepper ${sizeClass}`} role="group" aria-label={ariaLabel}>
      <button
        type="button"
        className="vote-btn vote-minus"
        aria-label="Decrease"
        aria-disabled={!canDec}
        disabled={!canDec}
        onClick={() => step(-1)}
      >
        –
      </button>

      <div className="vote-value" aria-live="off">
        {clamp(value)}
      </div>

      <button
        type="button"
        className="vote-btn vote-plus"
        aria-label="Increase"
        aria-disabled={!canInc}
        disabled={!canInc}
        onClick={() => step(1)}
      >
        +
      </button>
    </div>
  );
}
